export const LAYOUT_MAX_WIDTH = 2400;

/** Shared left/right edge padding for the header, nav row, page content, and
 * footer, so they always line up instead of drifting apart independently. */
export const PAGE_HORIZONTAL_PADDING = { xs: 1, sm: 1.5, md: 2, lg: 2.5 };

/** Fixed height for the top-of-page banners (GeoBlockBanner, StreakBanner) so they
 * stack with an identical, predictable height regardless of message length/locale. */
export const TOP_BANNER_HEIGHT = 40;
